export default __webpack_public_path__ + "static/media/btn-zeroback-start-fr_fr@3x.563cd67f.png";